import { addMinutes, format } from "date-fns"
import { useCallback } from "react"
import { useSelector } from "react-redux"
import { getUserProfile } from "~/reducers/userProfile"

type FormatParameters = Parameters<typeof format>

interface UserTimeFormat {
  (date: string | Date | number, formatStr: string, options?: FormatParameters[2]) : string
}


export const useUserTimeFormat = (): UserTimeFormat => {
  const user = useSelector(getUserProfile)

  const formatWrapped : UserTimeFormat = useCallback((date, formatStr, options?) => {
    const browserOffset = -(new Date().getTimezoneOffset())
    // every Date instance is implicitly in browser timezone 
    const dt = buildDateTime(new Date(date), browserOffset)

    if (user?.timeZoneOffset !== undefined) {
      dt.shiftToTimezone(user.timeZoneOffset)
    }
    const d = dt.getDate()
    return format(d, formatStr, options)
  }, [JSON.stringify(user)])

  return formatWrapped
}

export function buildDateTime(date:Date, timezoneOffset:number) {
  let d = date
  let offset = timezoneOffset

  const shiftToTimezone = (targetTimezoneOffset:number) => {
    d = addMinutes(d, - offset + targetTimezoneOffset)
    offset = targetTimezoneOffset
  }

  const elapse = (minutes:number) => {
    d = addMinutes(d, minutes)
  }

  const toISOString = () => {
    const offset0 = offset
    shiftToTimezone(-(new Date().getTimezoneOffset()))
    const d1 = d
    shiftToTimezone(offset0)
    return d1.toISOString()
  }

  const getDate = () => new Date(d)
  const getTimezoneOffset = () => offset

  return {
    shiftToTimezone,
    elapse,
    toISOString,
    getDate,
    getTimezoneOffset,
  }
}


